class Icons {

  icons = {
    temperature: {
      src: `<svg xmlns="http://www.w3.org/2000/svg" width="6.95" height="13.92" viewBox="0 0 6.95 13.92"><path d="M1.61,8.25A2.84,2.84,0,0,0,.5,10.55a2.9,2.9,0,0,0,3,2.87c1.94,0,2.94-1.17,3-2.52a3.23,3.23,0,0,0-1.3-2.71l0-6.08S5,.5,3.5.5A2,2,0,0,0,1.61,1.91Z" fill="none" stroke="$$color" stroke-miterlimit="10"/><circle cx="4.4" cy="10.65" r="2.05" fill="$$color"/><rect x="3.48" y="4.32" width="1.67" height="5.18" rx="0.83" fill="$$color"/></svg>`,
      width: 10,
    },
    humidity: {
      src: `<svg xmlns="http://www.w3.org/2000/svg" width="10.1" height="13.65" viewBox="0 0 10.1 13.65"><path d="M5.1.89,1.17,6.65a3.84,3.84,0,0,0,.48,4.88,4.48,4.48,0,0,0,6.63.29A3.91,3.91,0,0,0,9.11,7C8.33,5.63,5.1.89,5.1.89Z" fill="none" stroke="$$color" stroke-miterlimit="10"/><ellipse cx="5.86" cy="9.16" rx="3.48" ry="3.63" fill="$$color"/><polygon points="2.47 8.36 5.12 1.42 9.19 8.07 2.47 8.36" fill="$$color"/></svg>`,
      width: 12,
    },
    probe_temp: {
      src: `<svg xmlns="http://www.w3.org/2000/svg" width="31" height="46.5" viewBox="0 0 31 46.5"><circle cx="7.5" cy="29.5" r="6" fill="none" stroke="$$color" stroke-miterlimit="10" stroke-width="3"/><circle cx="5.5" cy="27.5" r="3.5" fill="$$color"/><path d="M10.5,24V6.5c0-2.76-1.46-5-3.25-5S4,3.74,4,6.5L4.4,25" fill="none" stroke="$$color" stroke-miterlimit="10" stroke-width="3"/><rect x="7" y="6" width="3" height="17" fill="$$color"/><path d="M7.5,35.5v4.87S7,45,16,45h8.63s4.87-.5,4.87-6.5v-36" fill="none" stroke="$$color" stroke-miterlimit="10" stroke-width="3"/></svg>`,
      width: 14,
    },
    battery: {
      src: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7"><rect x="1.5" y="0.5" width="10" height="6" rx="0.68" fill="none" stroke="$$color" stroke-miterlimit="10"/><rect y="2" width="1.5" height="2.77" rx="0.75" fill="$$color"/><polygon points="6.92 6 11 0.68 11 6 6.92 6" fill="$$color"/></svg>`,
      width: 18,
    },
    power: {
      src: `<svg xmlns="http://www.w3.org/2000/svg" width="6.48" height="12.38" viewBox="0 0 6.48 12.38"><polygon points="2.81 0 5.71 0 3.58 4.11 6.48 6.27 1.65 12.38 3 6.76 0 4.11 2.81 0" fill="$$color"/></svg>`,
      width: 10,
    },
    connection: {
      src: `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4.5" fill="none" stroke="$$color" stroke-miterlimit="10"/><line x1="2" y1="8.35" x2="7.7" y2="1.4" fill="none" stroke="$$color" stroke-miterlimit="10"/></svg>`,
      width: 16,
    },
  }

  getIcon(key, color="red") {

    let icon = this.icons[key];
    let svg = null;
    let width = 10;

    if(icon) {
      svg = icon.src.replaceAll("$$color", color);
      width = icon.width;
    } else {
      svg = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><rect width="10" height="10" fill="pink"/></svg>`;
    }

    const base64 = btoa(svg);
    return `<img src="data:image/svg+xml;base64,${base64}" width="${width}" />`;
  }

}

const IconsInstance = new Icons();

export default IconsInstance;
